module.exports = __webpack_public_path__ + "static/media/MVI-logo-with-name.1bd46c72.png";